import { ChangeDetectionStrategy, Component, Input, ViewEncapsulation } from '@angular/core';
import { AccordionModule } from 'primeng/accordion';
import { FullNamePipe } from '../../../../shared/pipes/full-name.pipe';
import { InformationEntityComponent } from '../../../../shared/components/information-entity/information-entity.component';
import { IContactDetails } from '../../../../shared/models/contact-details.model';
import { PhoneNumberPipe } from '../../../../shared/pipes/phone-number.pipe';

@Component({
  selector: 'cv-contact-details',
  standalone: true,
  imports: [AccordionModule, FullNamePipe, InformationEntityComponent, PhoneNumberPipe],
  templateUrl: './contact-details.component.html',
  styles: `
    .p-accordion .p-accordion-content.info-card .name {
      flex: 0 1 100%;
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class ContactDetailsComponent {
  @Input({ required: true }) data!: IContactDetails;
}
